import { render, staticRenderFns } from "./addDocsModal.vue?vue&type=template&id=5def3621&scoped=true&"
import script from "./addDocsModal.vue?vue&type=script&lang=js&"
export * from "./addDocsModal.vue?vue&type=script&lang=js&"
import style0 from "./addDocsModal.vue?vue&type=style&index=0&id=5def3621&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5def3621",
  null
  
)

export default component.exports